module.exports = __webpack_public_path__ + "static/media/playimg.e38ef78d.svg";